import React, { useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import SVG from "react-inlinesvg";
import {
  errorMessage,
  formatDate,
  formatStatus,
  formatUsername,
  permissionCssClass,
} from "../../../util/Helpers";
import { Button } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useSelector } from "react-redux";
import ApproveSocialRequestModal from "../pages/modals/ApproveSocialRequestModal";
import DeclineSocialRequestModal from "../pages/modals/DeclineSocialRequestModal";
import ViewRequestDetailsModal from "../pages/modals/ViewRequestDetailsModal";
import { ViewIcon } from "../../../util/Icons";

export const SocialRequestTable = ({ userGroup, category }) => {
  const tableRef = useRef();
  const adminUser = useSelector((state) => state.auth.user);

  const [approveSocialRequestModal, setApproveSocialRequestModal] = useState({
    showApproveSocialRequestModal: false,
    details: null,
  });

  const [declineSocialRequestModal, setDeclineSocialRequestModal] = useState({
    showDeclineSocialRequestModal: false,
    details: null,
  });

  const [viewRequestDetailsModal, setViewRequestDetailsModal] = useState({
    showViewRequestDetailsModal: false, 
    details: null,
  });
  

  /* Modal show/hide Toggle */
  const toggleViewRequestDetailsModal = (modal) => (_) => {
    setViewRequestDetailsModal({
      ...viewRequestDetailsModal,
      [modal]: !viewRequestDetailsModal[modal], 
    });
    // Refresh table when modal closes
    if (viewRequestDetailsModal[modal]) {
        tableRef.current?.refresh();
    }
  };

  const viewRequestDetails = (details) => {  
    setViewRequestDetailsModal({
      ...viewRequestDetailsModal,
      showViewRequestDetailsModal: true,
      details,
    });
  };

  const renderRequestId = (requestId) => {
    const truncatedId = requestId?.slice(0, 6) + "...";
  
    const handleCopy = () => {
      navigator.clipboard.writeText(requestId);
      cogoToast.success("Request ID copied to clipboard!");
    };
  
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
        <span title={requestId} style={{ cursor: "pointer" }}>
          {truncatedId}
        </span>
        <span
          onClick={handleCopy}
          title="Copy Request ID"
          style={{
            cursor: "pointer",
            color: "green",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          📋
        </span>
      </div>
    );
  };
  

  /* Action Buttons */
  const socialAction = (row) => {
    return (
      <span style={{ whiteSpace: "nowrap" }}>
        <Button
          title="View Request Details"  
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={(_) => viewRequestDetails(row)} 
        >
         <span className="svg-icon svg-icon-md svg-icon-primary">
            <ViewIcon />
          </span>
        </Button>
      </span>
    );
  };

  return (
    <>
      <FilterGroup
        defaultFilters={{
          endDate: new Date().toISOString().split("T")[0],
        }}
        key={category}
      >
        <FilterGroup.DateRange className={"mb-4"} />
        <FilterGroup.Content className="mt-5">
          {({ filters }) => {
            return (
              <Card>
                <CardHeader title={`Power User Requests`} />
                <CardBody>
                  <DynamicSimpleTable
                    key={`${userGroup}`}
                    queryParams={
                      `userGroup=${userGroup}` +
                      `&limit=${10}` +
                      `&startDate=${filters?.startDate || ""}` +
                      `&endDate=${filters?.endDate || ""}`
                    }
                    searchBox={false}
                    source={{ url: `/social/requests` }}
                    columns={[
                      {
                        title: "Request ID",
                        key: "requestId",
                        format: (row) => renderRequestId(row.requestId),
                      },
                      {
                        title: "User",
                        format: (row) =>
                          formatUsername(
                            row.socialUserId,
                            row.username,
                            null,
                            null,
                            "social"
                          ),
                      },
                      {
                        title: "Status",
                        format: (row) => formatStatus(row.status),
                      },
                      {
                        title: "Created At",
                        format: (row) => formatDate(row.created),
                      },
                      {
                        title: "Fee",
                        format: (row) => row.meta.subscriptionFee || "NA",
                      },
                      {
                        title: "Currency",
                        format: (row) => row.meta.feeCurrency || "NA",
                      },
                      { title: "", format: socialAction },
                    ]}
                    ref={tableRef}
                    onError={(err) => cogoToast.error(errorMessage(err))}
                    refreshIcon={true}
                  />
                </CardBody>
              </Card>
            );
          }}
        </FilterGroup.Content>
      </FilterGroup>
      {viewRequestDetailsModal.showViewRequestDetailsModal && ( 
        <ViewRequestDetailsModal
          {...viewRequestDetailsModal}
          tableRef={tableRef}
          onHide={toggleViewRequestDetailsModal("showViewRequestDetailsModal")} 
        />
      )}
    </>
  );
};
